import { COLOR, line, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'ROC',
  version: 2,
  label: 'Rate of Change',
  pane: 'sub',
  category: 'momentum',
  series: 'normal',
  precision: 2,
  order: 120,
  inputs: [period('timeperiod', 10, 'Length', 1)],
  outputs: [line('roc', 'ROC', COLOR.blue)],
  talib: { functions: ['ROC'], expr: 'ROC(close, timeperiod={timeperiod})' },
  listed: true,
  tailSafe: true,
  lookback: ({ timeperiod }) => timeperiod,
}
export default def
